
export const buildResourceRoute = (resource) =>
{
    const { resource_id, collection_id } = resource;
    return collection_id ? `/colecciones/${resource_id}` : `/recurso/${resource_id}`;
}
